import React from 'react';
import { Link } from 'react-router-dom';

const CtaBanner: React.FC = () => {
  return (
    <section className="max-w-[1280px] mx-auto px-5 sm:px-10 py-20">
      <div className="relative bg-gradient-to-br from-brand-navy to-brand-navy-light rounded-3xl px-10 py-16 text-center overflow-hidden">
        <div
          className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(200,16,46,0.15),transparent_60%),radial-gradient(circle_at_70%_50%,rgba(255,184,0,0.12),transparent_50%)]"
          aria-hidden="true"
        />
        <div className="relative z-10">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white mb-3.5">
            Ready to Stock Your Shelves?
          </h2>
          <p className="text-[17px] text-white/65 max-w-[500px] mx-auto leading-relaxed mb-8">
            Apply for a wholesale account today and get access to our full catalogue and B2B pricing.
          </p>
          <div className="flex flex-col sm:flex-row gap-3.5 justify-center">
            <Link
              to="/apply"
              className="bg-brand-teal text-white px-8 py-3.5 font-semibold text-[15px] rounded-[10px] hover:bg-brand-teal-dark transition-all shadow-lg shadow-brand-teal/25 hover:-translate-y-0.5"
            >
              Apply for Wholesale Account
            </Link>
            <a
              href="mailto:info@theyaadshop.com"
              className="bg-white/10 text-white border border-white/20 px-8 py-3.5 font-semibold text-[15px] rounded-[10px] hover:bg-white/20 transition-colors inline-block"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
